import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import './MainPage.scss'
import { useSelector } from "react-redux";
import { selectUser } from '../../utils/redux/userSlice'
import PageTitle from '../PageTitle/PageTitle.component';
import AwayterFavIcon from './../../utils/resources/logo_aw_pastilla6.png'
import { GetRouteLinks } from '../../utils/routeLinks';
import AwayterConnect from './../../utils/resources/awayter_connect_dark.png'
import { useTheme } from '../../utils/contexts/ThemeContext';
import { SideBar } from 'aw-sidebar';



const MainPage = (props: { changeLang: (id: string) => void }) => {
    const user = useSelector(selectUser)
    const [title, setTitle] = useState("");
    const [showMenu, setShowMenu] = useState(false)
    const { theme, getCustomThemeImage } = useTheme()

    return (

        <div id='sideBarContainer'>
            <div className="row flex-nowrap" id="sideBarRow">
                <SideBar role={user.role} routerLinks={GetRouteLinks()} showMenu={showMenu} smallImg={theme === 'custom' && getCustomThemeImage("icon") ? getCustomThemeImage("icon") : AwayterFavIcon} companyImg={user.company.image}
                    bigImg={theme === 'custom' && getCustomThemeImage("logo") ? getCustomThemeImage("logo") : AwayterConnect} bgColor='var(--sidebar)' activeColor='var(--accent-color)' textColor='var(--sidebar-text)' />
                <div className='col p-0' id='contentScreenDiv'>
                    <PageTitle changeLang={props.changeLang} realTitle={title} setShowMenu={() => setShowMenu(!showMenu)} />
                    <Outlet context={{ setState: setTitle }} />
                </div>
            </div>
        </div >

    )
}
export default MainPage